module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "backend-container"
  }, [_c('div', {
    staticClass: "desktop-container"
  }, [_c('div', {
    staticClass: "block-60"
  }), _vm._v(" "), _c('div', {
    staticClass: "main-container"
  }, [_c('div', {
    staticClass: "left-container"
  }, [_c('div', {
    staticClass: "developer-container"
  }, [_c('img', {
    staticClass: "header-img",
    attrs: {
      "src": '/static/img' + _vm.developer.header,
      "alt": ""
    },
    on: {
      "click": function($event) {
        return _vm.clickMenu(8)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "developer-info"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.developer.name))]), _vm._v(" "), _c('div', {
    staticClass: "phone-container"
  }, [_c('div', {
    staticClass: "phone-no"
  }, [_vm._v(_vm._s(_vm.developer.mobile))]), _vm._v(" "), _c('div', {
    staticClass: "quit",
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("退出")])])])]), _vm._v(" "), _c('div', {
    staticClass: "menus"
  }, _vm._l((_vm.menus), function(item) {
    return _c('div', {
      key: item.label,
      staticClass: "menu",
      class: item.active ? 'active' : '',
      on: {
        "click": function($event) {
          return _vm.menuClick(item)
        }
      }
    }, [_c('div', {
      staticClass: "iconfont",
      class: item.icon
    }), _vm._v(" "), _c('div', {
      staticClass: "menu-label"
    }, [_vm._v(_vm._s(item.label))])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "right-container"
  }, [_c('div', [_c('el-breadcrumb', {
    attrs: {
      "separator": "/"
    }
  }, [_c('el-breadcrumb-item', [_vm._v("开放平台")]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v("首页")]), _vm._v(" "), (_vm.breadcrumb) ? _c('el-breadcrumb-item', [_vm._v(_vm._s(_vm.breadcrumb))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "right-main"
  }, [_c('router-view', {
    on: {
      "jump": _vm.jump,
      "clickMenu": _vm.clickMenu,
      "changeHeader": _vm.changeHeader,
      "changeName": _vm.changeName
    }
  })], 1)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0b2a5c9e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/backend.vue
// module id = 325
// module chunks = 1